import type { CustomOrderStatus } from '../api/customOrdersApi';

// Mirrors the shared StatusBadge pill styling, but for custom-order statuses
// (the shared one is typed to regular Order statuses).
const CONFIG: Record<CustomOrderStatus, { label: string; bg: string; fg: string }> = {
  DRAFT: { label: 'Draft', bg: '#EFEFF1', fg: '#5B5A5E' },
  MEDIA_PROCESSING: { label: 'Processing media', bg: '#FEFECD', fg: '#7A6B00' },
  AWAITING_PAYMENT: { label: 'Awaiting payment', bg: '#E2DEF7', fg: '#4B3FA6' },
  ORDER_CONFIRMED: { label: 'Confirmed', bg: '#E1FEE3', fg: '#1E7A36' },
  ABANDONED: { label: 'Abandoned', bg: '#FCE2E2', fg: '#A63F3F' },
};

export const CustomOrderStatusBadge = ({ status }: { status: CustomOrderStatus }) => {
  const c = CONFIG[status] ?? { label: status, bg: '#EFEFF1', fg: '#5B5A5E' };
  return (
    <span
      className="text-[11px] font-[600] px-2 py-0.5 rounded-full whitespace-nowrap"
      style={{ backgroundColor: c.bg, color: c.fg }}
    >
      {c.label}
    </span>
  );
};
